import { objectOf, string } from 'prop-types';

export default {
  data: objectOf({
    uuid: string,
    url: string,
    title: string,
    excerpt: string,
    feature_image: string,
    published_at: string,
    primary_author: objectOf({
      name: string,
      profile_image: string,
    }),
  }),
};



// WEBPACK FOOTER //
// ./src/scripts/modules/BlogPreview/propTypes.js